import { createI18n } from 'vue-i18n'
import { locales, IT } from '@/libraries/localization.js'

export const i18n = createI18n({
    legacy: false,
    fallbackLocale: IT,
    messages: locales,
    warnHtmlMessage: false,
})
